import { useState } from 'react';
import './DayTrackedTimeStats.css';
import type { TrackedTimeForDayDetails } from './models';
import { CIRCLE_COLORS_ELEMENT } from './constants/circleColors';
import TimerIcon from './icons/TimerIcon';
import TimeSettingsDropDown, {
  type TimeFormat,
  type TimeZone,
} from './components/TimeSettingsDropDown';
import TotalTimeCard from './components/TotalTimeCard';
import WorkLogList from './components/WorkLogList';

export type DayTrackedTimeItem = {
  DetailInfo: TrackedTimeForDayDetails;
};

type DayTrackedTimeStatsProps = {
  value: DayTrackedTimeItem;
};

const DayTrackedTimeStats = ({ value }: DayTrackedTimeStatsProps) => {
  const { Total, TrackedManually, TrackedWithTracker, Overtime, Date: dateDay } = value.DetailInfo;
  const formatted = new Date(dateDay).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
  const [timeZone, setTimeZone] = useState<TimeZone>('utc');
  const [timeFormat, setTimeFormat] = useState<TimeFormat>('12h');

  return (
    <div className="day-tracked-time-stats">
      <div className="day-tracked-time-stats-header">
        <h3>{formatted}</h3>
        <TimeSettingsDropDown
          timeZone={timeZone}
          timeFormat={timeFormat}
          onValueChangeCallback={(nextTimeZone, nextTimeFormat) => {
            setTimeFormat(nextTimeFormat);
            setTimeZone(nextTimeZone);
          }}
        />
      </div>
      <div className="stats-cards">
        <TotalTimeCard label="Total time" value={Total} infoIcon={<TimerIcon />} />
        <TotalTimeCard
          label="Tracked"
          value={TrackedWithTracker}
          infoIcon={CIRCLE_COLORS_ELEMENT.trackedWithTracker}
        />
        <TotalTimeCard
          label="Manual"
          value={TrackedManually}
          infoIcon={CIRCLE_COLORS_ELEMENT.manually}
        />
        <TotalTimeCard
          label="Overtime"
          value={Overtime}
          infoIcon={CIRCLE_COLORS_ELEMENT.overtime}
        />
      </div>
      <WorkLogList timeFormat={timeFormat} timeZone={timeZone} value={value.DetailInfo.WorkLogs} />
    </div>
  );
};

export default DayTrackedTimeStats;
